import FuelType from "./FuelType"

class FuelConsum{

    fuel : FuelType = new FuelType()
    consumption : number = 0;

}

export default FuelConsum